import React from 'react';

function Button({ children, classes, disabled, onClick, ...rest }) {
  return  (
    <div
      className={`${classes && classes} ${disabled ? "disabled" : ""}`}
      {...rest}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export default Button;


// WEBPACK FOOTER //
// ./src/theme/Button.js